import { useFormState } from 'informed';
import { useReduxState } from 'hooks';
import {
  Checkbox,
  Emails,
  FormGroup,
  FormSection,
  NumberStepper,
  ReminderIntervalsSelector
} from 'components/common/form';

interface Props {
  requireExpiration?: boolean;
}

const SettingsCompletionExpiration = ({ requireExpiration = false }: Props) => {
  const { messages } = useReduxState();

  const formState = useFormState();

  const sectionEnabled = formState.values?.completionEnabled;
  const expirationEnabled = formState.values?.completionExpiration;

  return (
    <FormSection title={messages.settingsCompletionExpiration}>
      <Checkbox
        disabled={requireExpiration || !sectionEnabled}
        field="completionExpiration"
        id="completion-expiration"
        label={messages.settingsCompletionExpirationSet}
      />

      <NumberStepper
        disabled={!expirationEnabled}
        field="completionExpirationValue"
        id="completion-expiration-value"
        label={messages.settingsCompletionExpirationTime}
        min={1}
        max={1200}
        stepValue={1}
        style={{ marginTop: 10 }}
      />

      <FormGroup label={messages.commonEmailReminders}>
        <Checkbox
          disabled={!expirationEnabled || !sectionEnabled}
          field="completionExpirationReminders"
          id="completion-expiration-reminders"
          label={messages.commonSendEmailReminders}
        />

        <Checkbox
          disabled={!expirationEnabled || !sectionEnabled}
          field="completionExpirationRemindersOthers"
          id="completion-expiration-reminders-others"
          label={`${messages.commonSendAdditionalEmailReminders}:`}
          style={{ marginTop: 10 }}
        />

        <Emails
          disabled={
            !expirationEnabled ||
            !sectionEnabled ||
            !formState.values.completionExpirationRemindersOthers
          }
          field="completionExpirationRemindersEmailList"
          id="completion-expiration-reminders-email-list"
          style={{ marginLeft: 20, marginTop: 8 }}
        />

        <ReminderIntervalsSelector
          disabled={!expirationEnabled || !sectionEnabled}
          field="completionExpirationReminderIntervals"
          type="completion"
        />
      </FormGroup>
    </FormSection>
  );
};

export default SettingsCompletionExpiration;
